// @flow
export type UploadResponse = {
  public_id: string,
  version: number,
  width: number,
  height: number,
  format: string,
  created_at: string,
  resource_type: string,
  tags: string[],
  bytes: number,
  type: string,
  etag: string,
  url: string,
  secure_url: string,
  signature: string,
  original_filename: string,
  delete_token: string,
};

export interface Resource {
  +id: string;
  +resourceType: string;
}

export class RemoteResource implements Resource {
  accessType: string;
  resourceType: string;
  url: string;
  constructor(props: *) {
    this.accessType = props.accessType;
    this.resourceType = props.resourceType;
    this.url = props.url;
  }
  get id(): string {
    return this.url;
  }
  serialize(captionMap: Map<string, string>) {
    if (this.accessType === 'upload') {
      throw new Error(
        'Only Youtube RemoteResource type may be persisted to the document store.'
      );
    }
    return {
      url: this.url,
      resource_type: this.resourceType,
      caption: captionMap.get(this.id),
    };
  }
}

export class FileSystemResource implements Resource {
  file: File;
  constructor(file: File) {
    this.file = file;
  }
  get id(): string {
    return this.file.name;
  }
  get resourceType(): string {
    return this.file.type.split('/').shift();
  }
}

export type AccessType = 'upload' | 'youtube';
export class CloudResource implements Resource {
  $id: string;
  public_id: string;
  resource_type: string;
  url: string;
  delete_token: string;
  access_type: AccessType;

  constructor(
    id: string,
    props: UploadResponse,
    accessType: AccessType = 'upload'
  ) {
    this.$id = id;
    this.public_id = props.public_id;
    this.resource_type = props.resource_type;
    this.url = props.secure_url || props.url;
    this.delete_token = props.delete_token;
    this.access_type = accessType;
  }
  get id(): string {
    return this.$id;
  }
  get resourceType(): string {
    return this.resource_type;
  }
  serialize(captionMap: Map<string, string>) {
    return {
      url: this.url,
      resource_type: this.resource_type,
      caption: captionMap.get(this.id),
      public_id: this.public_id,
    };
  }
}

export class ResourceTypes {
  static isUploadable(res: Resource) {
    if (res instanceof FileSystemResource) {
      return true;
    } else if (res instanceof RemoteResource && res.accessType === 'upload') {
      return true;
    }

    return false;
  }
  static getUploadProps(res: *) {
    const file = res.file || res.url || null;

    if (file === null) {
      throw new Error('');
    }

    return [file, res.resourceType];
  }
  static isSerializable(res: *) {
    if (res instanceof RemoteResource && res.accessType === 'upload') {
      return false;
    }

    return typeof res.serialize === 'function';
  }
}



// WEBPACK FOOTER //
// ./src/components/ContentSection/__future__/MediaUpload/ResourceTypes.js